import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Grid,
  Paper,
  Divider,
  IconButton,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { VscLinkExternal } from "react-icons/vsc";
import { useTheme as useCustomTheme } from "../../style/theme";

const AddressDetail = () => {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    country: "",
    streetAddress: "",
    aptSuite: "",
    suburb: "",
    city: "",
    postalCode: "",
    state: "",
    nickname: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCancel = () => {
    setShowForm(false);
    setFormData({
      fullName: "",
      country: "",
      streetAddress: "",
      aptSuite: "",
      suburb: "",
      city: "",
      postalCode: "",
      state: "",
      nickname: "",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Saved Address:", formData);
    setShowForm(false);
  };
  const { mode } = useCustomTheme();

  return (
    <Box sx={{ py: 4, color: "#fff", px: 2 }}>
      <Typography variant="body2" mb={2}>
        Addresses that you add can be used across Clikkle products and services,
        like autofill on our products.{" "}
        <Typography
          component="span"
          sx={{ color: "#4dabf7", cursor: "pointer" }}
        >
          Learn more about these addresses
        </Typography>
      </Typography>

      {/* Sample Saved Address Display */}
      {!showForm && (
        <Paper
          elevation={0}
          sx={{
            p: 2,
            backgroundColor: "#121212",
            border: mode === "light"
                ? "1px solid #e5e7eb"
                : "1px solid #2e2e2e",
            mb: 2,
            background: "transparent",
          }}
        >
          <Button
            variant="outlined"
            sx={{
              color: "#0080FF",
              borderColor: "#0080FF",
              mb: 3,
              textTransform: "none",
              px: 4,
              borderRadius: 6,
            }}
            onClick={() => setShowForm(true)}
          >
            + Add address
          </Button>

          {/* <Typography>No.5 Westville avenue, Accra, Ghana</Typography> */}

          <Box
            mt={2}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box>
              <Typography fontWeight="semibold">
                No.5 Westville avenue, Accra, Ghana
              </Typography>
            </Box>
            <IconButton>
              <ArrowForwardIosIcon sx={{ color: "#fff", fontSize: 16 }} />
            </IconButton>
          </Box>

          <Divider sx={{ my: 2, borderColor: "#333" }} />

          <Box
            mt={2}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box>
              <Typography fontWeight="bold">Profile addresses</Typography>
              <Typography variant="body2" color="#aaa">
                you can make these visible to others across Clikkle products and
                services
              </Typography>
            </Box>
            <IconButton>
              <ArrowForwardIosIcon sx={{ color: "#fff", fontSize: 16 }} />
            </IconButton>
          </Box>

          <Divider sx={{ my: 2, borderColor: "#333" }} />

          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box>
              <Typography fontWeight="bold">Billing addresses</Typography>
              <Typography variant="body2" color="#aaa">
                Manage addresses for your payment methods
              </Typography>
            </Box>
            <IconButton>
              <VscLinkExternal sx={{ color: "#fff", fontSize: 20 }} />
            </IconButton>
          </Box>
        </Paper>
      )}

      {/* Address Form */}
      {showForm && (
        <Paper
          elevation={3}
          sx={{
            p: 3,
            backgroundColor: "transparent",
            border: "1px solid #2c2c2c",
          }}
          component="form"
          onSubmit={handleSubmit}
        >
          <Grid container spacing={1}>
            {[
              {
                label: "Full Name",
                name: "fullName",
                required: true,
                placeholder: "Enter full name",
              },
              {
                label: "Country/Region",
                name: "country",
                required: true,
                placeholder: "Select",
              },
              {
                label: "Street Address",
                name: "streetAddress",
                required: true,
                placeholder: "Enter address",
              },
              {
                label: "Apt/Suite (optional)",
                name: "aptSuite",
                placeholder: "Enter name",
              },
              {
                label: "Suburb (optional)",
                name: "suburb",
                placeholder: "Enter name",
              },
              {
                label: "City",
                name: "city",
                required: true,
                placeholder: "Enter name",
              },
              {
                label: "Postal Code",
                name: "postalCode",
                required: true,
                placeholder: "Enter code",
              },
              {
                label: "State",
                name: "state",
                required: true,
                placeholder: "Select",
              },
              {
                label: "Nickname (optional)",
                name: "nickname",
                placeholder: "Enter nickname",
              },
            ].map((field, index) => (
              <Grid item xs={12} key={index}>
                <Typography variant="body2" mb={1} color="#FFFF">
                  {field.label}*
                </Typography>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder={field.placeholder}
                  name={field.name}
                  value={formData[field.name]}
                  onChange={handleChange}
                  required={field.required}
                  InputLabelProps={{ style: { color: "#aaa" } }}
                  InputProps={{
                    style: {
                      color: "#fff",
                    },
                  }}
                />
              </Grid>
            ))}

            <Grid
              item
              xs={12}
              display="flex"
              justifyContent={"flex-end"}
              gap={2}
            >
              <Button
                type="button"
                variant="contained"
                onClick={handleCancel}
                sx={{
                  border: "1px solid rgb(53, 53, 53)",
                  background: "transparent",
                  boxShadow: "none",
                  px: 6,
                }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                sx={{ backgroundColor: "#0080FF", px: 6 }}
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </Paper>
      )}
    </Box>
  );
};

export default AddressDetail;
